import React from "react";

// Background + Member Images
import bgTeam from "../../../images/bg/team-bg.png";
import noiseBg from "../../../images/team/noice-bg.png";

import img01 from "../../../images/team/Dani.jpg";
import img02 from "../../../images/team/Fer.jpg";
import img05 from "../../../images/team/Miguel-01.jpg";
import img06 from "../../../images/team/Ale-01.jpg";
import img09 from "../../../images/team/LogoGenus.png";

const teamMembers = [
  {
    name: "GENUS FILMS",
    role: "Empresa",
    img: img09,
    linkedin: "https://www.linkedin.com/company/genus-films/",
  },
  {
    name: "Daniel razo",
    role: "Jefe del equipo",
    img: img01,
    linkedin: "https://www.linkedin.com/in/daniel-luna-razo-191419114/",
  },
  {
    name: "Fernanda Romero",
    role: "Admin. de prod.",
    img: img02,
    linkedin: "https://www.linkedin.com/in/fernanda-romero-g/",
  },
  {
    name: "Alejandra Piña",
    role: "Editor / Motion Grapher",
    img: img06,
    linkedin: "https://www.linkedin.com/in/karla-alejandra-pi%C3%B1a-ontiveros-9b1315242/",
  },
  /*
    {
    name: "Miguel Olive",
    role: "Editor / Motion Grapher",
    img: img05,
    linkedin: "https://www.linkedin.com/",
    },

  
  {
    name: "Chris",
    role: "Editor / Motion Grapher",
    img: img03,
    linkedin: "https://www.linkedin.com/in/chris/",
  },
  {
    name: "Elías Rodríguez",
    role: "Editor / Motion Grapher",
    img: img04,
    linkedin: "https://www.linkedin.com/in/elias/",
  },
  {
    name: "Isaac Almazan",
    role: "Editor / Motion Grapher",
    img: img07,
    linkedin: "https://www.linkedin.com/in/isaac/",
  },
  {
    name: "David",
    role: "Fotografo / Videografo",
    img: img08,
    linkedin: "https://www.linkedin.com/in/david/",
  },
  */
];

const TeamSection: React.FC = () => {
  return (
    <section
      className="team pt-140 pb-150 bg_img"
      style={{ backgroundImage: `url(${bgTeam})` }}
    >
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-45">
          <span className="sub-title mb-20">Linkedin</span>
          <h2 className="title title-line_height">Linkedin</h2>
        </div>

        <div className="row mt-none-55">
          {teamMembers.map((member, i) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mt-55"
              key={i}
            >
              <div className="xb-team-item xb-border">
                <div className="xb-item--img">
                  <img src={member.img} alt={member.name} />
                </div>

                <div className="xb-item--holder ul_li_between">
                  <div className="xb-item--author">
                    <h2 className="xb-item--name">{member.name}</h2>
                    <span className="xb-item--desig">{member.role}</span>
                  </div>

                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="xb-item--social xb-border"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                </div>

                <div className="xb-bg">
                  <img src={noiseBg} alt="background texture" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
